<template>
    <CModal :title="personName" color="primary" :show.sync="value">
        <!-- Number of hours -->
        <CRow>
            <CCol sm="12">
                <CInput class="mb-0" label="Número de horas*" placeholder="" v-model="hours" type="number" min="1" step="1"/>
            </CCol>
        </CRow>
        <!-- Footer buttons -->
        <footer slot="footer">
            <button type="button" class="mr-1 btn btn-secondary" @click="cancelTapped"> Cancelar </button>
            <button type="button" class="ml-1 btn btn-primary" @click="okTapped"> Confirmar </button>
        </footer>
    </CModal>
</template>

<script>
export default {
    data()
    {
        return {
            hours: null,
        }
    },
    props:{    
        value:
        {
            type: Boolean,
            default: false
        },
        personName:
        {
            type: String,
            default: ''
        },
    },
    methods:
    {
        cancelTapped: function()
        {
            this.$emit('cancel-tapped');
            this.$emit('input', false);
        },
        okTapped: function()
        {
            this.$emit('ok-tapped', this.hours);
            this.$emit('input', false);
        }
    },
    watch:
    {
        value: function(val)
        {
            this.$emit('input', this.value);
        }
    }
}
</script>

<style>

</style>